import type { ReactNode } from 'react';
import { DebouncedSearchInput } from '@clay-run/glaze/debounced-search-input';

/** One body padding + gap for every rail/chat pane, so the search row and the first row sit at the same y in Chats, Plays and Actions. */
export const RAIL_PANE_PADDING = 'px-3 py-3';
export const RAIL_PANE_GAP = 'gap-3';

export interface RailSearchRowProps {
  'aria-label': string;
  placeholder: string;
  /** Uncontrolled seed; remount via `inputKey` to move the visible text. */
  initialValue?: string;
  inputKey?: string | number;
  onSearch: (value: string) => void;
  /** Right-aligned control beside the box (e.g. a scope/grouping dropdown). */
  trailing?: ReactNode;
}

/** The rail panes' one search-box row: a bordered `xs` search input with an optional trailing control. */
export function RailSearchRow({
  'aria-label': ariaLabel,
  placeholder,
  initialValue,
  inputKey,
  onSearch,
  trailing,
}: RailSearchRowProps) {
  return (
    // `min-h-7` = the `sm` trailing button's height, so a row with no trailing control is as tall as one with it.
    <div className="flex min-h-7 items-center gap-2">
      <DebouncedSearchInput
        key={inputKey}
        initialValue={initialValue}
        aria-label={ariaLabel}
        placeholder={placeholder}
        size="xs"
        variant="bordered"
        className="flex-1"
        onSearch={onSearch}
      />
      {trailing}
    </div>
  );
}
